/**
 * Disables MRT's built-in sort tooltip by blanking the localization strings.
 * A MUI <Tooltip> with an empty title renders nothing.
 */
export const NO_SORT_TOOLTIP_LOCALIZATION = {
  sortByColumnAsc: "",
  sortByColumnDesc: "",
  sortedByColumnAsc: "",
  sortedByColumnDesc: "",
};
